import { useRecoilState, useSetRecoilState } from "recoil";
import React from "react";
import { storyTagsAtom } from "@/store";
import { getStoryTagGroups } from "@/utils/net";
import { useRequest } from "@/utils/hooks";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar, Mousewheel } from 'swiper/modules';
import { storiesLoadedAtom } from "../../../../store/index.js";

const languages = [
  "ab",
  "aa",
  "af",
  "ak",
  "sq",
  "am",
  "ar",
  "an",
  "hy",
  "as",
  "av",
  "ae",
  "ay",
  "az",
  "bm",
  "ba",
  "eu",
  "be",
  "bn",
  "bh",
  "bi",
  "bs",
  "br",
  "bg",
  "my",
  "ca",
  "km",
  "ch",
  "ce",
  "ny",
  // "zh",
  "cu",
  "cv",
  "kw",
  "co",
  "cr",
  "hr",
  "cs",
  "da",
  "dv",
  "nl",
  "dz",
  // "en",
  "eo",
  "et",
  "ee",
  "fo",
  "fj",
  "fi",
  "fr",
  "ff",
  "gd",
  "gl",
  "lg",
  "ka",
  "de",
  "ki",
  "el",
  "kl",
  "gn",
  "gu",
  "ht",
  "ha",
  "he",
  "hz",
  "hi",
  "ho",
  "hu",
  "is",
  "io",
  "ig",
  "id",
  "ia",
  "ie",
  "iu",
  "ik",
  "ga",
  "it",
  "ja",
  "jv",
  "kn",
  "kr",
  "ks",
  "kk",
  "rw",
  "kv",
  "kg",
  "ko",
  "kj",
  "ku",
  "ky",
  "lo",
  "la",
  "lv",
  "lb",
  "li",
  "ln",
  "lt",
  "lu",
  "mk",
  "mg",
  "ms",
  "ml",
  "mt",
  "gv",
  "mi",
  "mr",
  "mh",
  "ro",
  "mn",
  "na",
  "nv",
  "nd",
  "ng",
  "ne",
  "se",
  "no",
  "nb",
  "nn",
  "ii",
  "oc",
  "oj",
  "or",
  "om",
  "os",
  "pi",
  "pa",
  "ps",
  "fa",
  "pl",
  "pt",
  "qu",
  "rm",
  "rn",
  "ru",
  "sm",
  "sg",
  "sa",
  "sc",
  "sr",
  "sn",
  "sd",
  "si",
  "sk",
  "sl",
  "so",
  "st",
  "nr",
  "es",
  "su",
  "sw",
  "ss",
  "sv",
  "tl",
  "ty",
  "tg",
  "ta",
  "tt",
  "te",
  "th",
  "bo",
  "ti",
  "to",
  "ts",
  "tn",
  "tr",
  "tk",
  "tw",
  "ug",
  "uk",
  "ur",
  "uz",
  "ve",
  "vi",
  "vo",
  "wa",
  "cy",
  "fy",
  "wo",
  "xh",
  "yi",
  "yo",
  "za",
  "zu",
];

const StoryTags = (props) => {
  const { displayType = 'default' } = props;
  const [storyTags, setStoryTags] = useRecoilState<Set<string | string[]>>(storyTagsAtom);
  const setStoriesLoaded = useSetRecoilState(storiesLoadedAtom); 

  const { data: tags, loading } = useRequest(
    async () => {
      const tags = await getStoryTagGroups();
      const others = tags.filter((tag) => languages.includes(tag.tagName)).map((l) =>l.tagName);
      return [
        {
          label: "Rodin Tips",
          value: "tip",
        },
        {
          label: "Tutorial",
          value: "tutorial",
        },
        {
          label: "Official",
          value: "official",
        },
        {
          label: "English",
          value: "en",
        },
        {
          label: "中文",
          value: "zh",
        },
        {
          label: "Other Languages",
          value: others,
        },
      ];
    },
    { initData: []}
  );

  const LoadingSkeleton = () => (
    <div className="flex gap-2 -mb-2 flex-wrap">
      {[1, 2, 3, 4, 5].map((item) => (
        <div
          key={item}
          className="px-4 py-2 h-8 rounded-lg bg-[#FFFFFF08] animate-pulse"
          style={{ width: `${Math.floor(Math.random() * (120 - 80) + 80)}px` }}
        />
      ))}
    </div>
  );

const handleTagClick = (tagValue) => {
  setStoryTags((prev) => {
    const newTags = prev.has(tagValue)
      ? new Set(prev.delete(tagValue) && prev)
      : new Set(prev.add(tagValue));
    return newTags;
  });
  setStoriesLoaded(false);
};

 

  const tagsDisplay = {
    'mini': (
       <Swiper    
            modules={[Scrollbar, Mousewheel]}
            grabCursor={true}
            speed={400}
            mousewheel={{
              invert: false,
            }}
            slidesPerView="auto"
            spaceBetween={8}
            className="w-full">
      {tags.map((tag) => (
        <SwiperSlide key={tag.label}  className="!w-auto">
        <div
          className={`px-4 py-2 text-[14px] leading-4 rounded-lg  transition-all cursor-pointer flex ${
            storyTags.has(tag.value)
              ? "text-[#20B6C0] bg-[#20B6C01A]"
              : "text-[#FFFFFF80] bg-[#FFFFFF08] hover:text-white"
          } 'flex-shrink-0 w-max`}
          key={tag.label}
         onClick={() => handleTagClick(tag.value)}
        >
          <div className="select-none">{tag.label}</div>
          <div
            className={`${
              storyTags.has(tag.value)
                ? "ml-[6px]"
                : "w-0"
            } overflow-hidden transition`}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.60417 11.3362C6.47396 11.3362 6.34375 11.2862 6.24479 11.1872L3.46563 8.40807C3.26667 8.20911 3.26667 7.88724 3.46563 7.68828C3.66458 7.48932 3.98646 7.48932 4.18542 7.68828L6.96458 10.4685C7.16354 10.6674 7.16354 10.9893 6.96458 11.1883C6.86458 11.2872 6.73437 11.3362 6.60417 11.3362Z"
                fill="#20B6C0"
              />
              <path
                d="M6.60234 11.3361C6.47214 11.3361 6.34193 11.2861 6.24297 11.1871C6.04401 10.9882 6.04401 10.6663 6.24297 10.4673L11.8023 4.90898C12.0013 4.71003 12.3232 4.71003 12.5221 4.90898C12.7211 5.10794 12.7211 5.42982 12.5221 5.62878L6.96276 11.1871C6.86276 11.2871 6.73255 11.3361 6.60234 11.3361Z"
                fill="#20B6C0"
              />
            </svg>
          </div>
        </div>
      </SwiperSlide>
      ))}
       </Swiper>

    ),
    'default': (
      loading ? <LoadingSkeleton /> : (
        <div className={`flex gap-2 -mb-2 flex-wrap`}>
          {tags.map((tag) => (
            <div
              className={`px-4 py-2 text-[14px] leading-4 rounded-lg  transition-all cursor-pointer flex ${
                  storyTags.has(tag.value)
                    ? "text-[#20B6C0] bg-[#20B6C01A]"
                    : "text-[#FFFFFF80] bg-[#FFFFFF08] hover:text-white"
                } ${displayType === 'mini' ? 'flex-shrink-0 w-max' : ''}`}
              key={tag.label}
             onClick={() => handleTagClick(tag.value)}
            >
              <div className="select-none">{tag.label}</div>
              <div
                className={`${
                  storyTags.has(tag.value)
                    ? "ml-[6px]"
                    : "w-0"
                } overflow-hidden transition`}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.60417 11.3362C6.47396 11.3362 6.34375 11.2862 6.24479 11.1872L3.46563 8.40807C3.26667 8.20911 3.26667 7.88724 3.46563 7.68828C3.66458 7.48932 3.98646 7.48932 4.18542 7.68828L6.96458 10.4685C7.16354 10.6674 7.16354 10.9893 6.96458 11.1883C6.86458 11.2872 6.73437 11.3362 6.60417 11.3362Z"
                    fill="#20B6C0"
                  />
                  <path
                    d="M6.60234 11.3361C6.47214 11.3361 6.34193 11.2861 6.24297 11.1871C6.04401 10.9882 6.04401 10.6663 6.24297 10.4673L11.8023 4.90898C12.0013 4.71003 12.3232 4.71003 12.5221 4.90898C12.7211 5.10794 12.7211 5.42982 12.5221 5.62878L6.96276 11.1871C6.86276 11.2871 6.73255 11.3361 6.60234 11.3361Z"
                    fill="#20B6C0"
                  />
                </svg>
              </div>
            </div>
          ))}
        </div>
      )
    )
  }

  return tagsDisplay[displayType];
}

export default React.memo(StoryTags);
